import { lazy, Suspense, useEffect, useState } from "react";
import ProtectedAdminGate from "./auth/ProtectedAdminGate";
import RequireAuth from "./auth/RequireAuth";
import AdminDataHealthPage from "components/midpoint/admin/AdminDataHealthPage";
import AdminPropertyImportPage from "components/midpoint/admin/AdminPropertyImportPage";
import RealEstateSourcesPage from "components/midpoint/admin/realEstateSources/RealEstateSourcesPage";
import RealEstateSourceControlsPage from "components/midpoint/admin/realEstateSources/RealEstateSourceControlsPage";
import SourceQualityPage from "components/midpoint/admin/realEstateSources/SourceQualityPage";
import ImageHealthPage from "components/midpoint/admin/realEstateSources/ImageHealthPage";
import ImageCachePage from "components/midpoint/admin/realEstateSources/ImageCachePage";
import MediaQualityDashboardPage from "components/midpoint/admin/realEstateSources/MediaQualityDashboardPage";
import GeocodeQueuePage from "components/midpoint/admin/GeocodeQueuePage";
import LocationQualityPage from "components/midpoint/admin/LocationQualityPage";
import DuplicateReviewPage from "components/midpoint/admin/DuplicateReviewPage";
import CanonicalListingsPage from "components/midpoint/admin/CanonicalListingsPage";
import RealEstateReviewQueuePage from "components/midpoint/admin/RealEstateReviewQueuePage";
import CommunityReportModeration from "components/midpoint/CommunityReportModeration";
import WeatherIntelligenceDashboardPage from "components/midpoint/WeatherIntelligenceDashboardPage";
import AdminUsersPage from "components/midpoint/admin/users/AdminUsersPage";
import AdminAuditLogPage from "components/midpoint/admin/audit/AdminAuditLogPage";
import AdminPrivacyOperationsPage from "components/midpoint/admin/privacy/AdminPrivacyOperationsPage";
import AdminIngestionLogsPage from "components/midpoint/admin/ingestion/AdminIngestionLogsPage";
import AdminRolesPage from "components/midpoint/admin/roles/AdminRolesPage";
import AdminPartnersPage from "components/midpoint/admin/partners/AdminPartnersPage";
import AdminLeadBrokerConfigPage from "components/midpoint/admin/leadBroker/AdminLeadBrokerConfigPage";
import AdminGeoBoundariesPage from "components/midpoint/admin/AdminGeoBoundariesPage";
import FoodSourceDiscoveryPage from "components/midpoint/admin/food/FoodSourceDiscoveryPage";
import FoodNormalizationPage from "components/midpoint/admin/food/FoodNormalizationPage";
import FoodNormalizationReviewPage from "components/midpoint/admin/food/FoodNormalizationReviewPage";
import FoodBasketCalculationPage from "components/midpoint/admin/food/FoodBasketCalculationPage";
import FoodWholesaleIngestionPage from "components/midpoint/admin/food/FoodWholesaleIngestionPage";
import FoodRetailIngestionPage from "components/midpoint/admin/food/FoodRetailIngestionPage";
import FoodSupplyIngestionPage from "components/midpoint/admin/food/FoodSupplyIngestionPage";
import FoodInputIngestionPage from "components/midpoint/admin/food/FoodInputIngestionPage";
import FoodAccessAdminPage from "components/midpoint/admin/food/FoodAccessAdminPage";
import FoodAccessOperationsPage from "components/midpoint/admin/food/FoodAccessOperationsPage";
import FoodStoreReviewQueuePage from "components/midpoint/admin/food/FoodStoreReviewQueuePage";
import FoodChainBranchLocatorStrategyPage from "components/midpoint/admin/food/FoodChainBranchLocatorStrategyPage";
import FoodChainBranchImportsPage from "components/midpoint/admin/food/FoodChainBranchImportsPage";
import ChainLocatorAuditPage from "components/midpoint/admin/food/ChainLocatorAuditPage";
import FoodStoreReconciliationPage from "components/midpoint/admin/food/FoodStoreReconciliationPage";
import FoodRecommendationAdminPage from "components/midpoint/admin/food/FoodRecommendationAdminPage";
import VehicleLookupsPage from "components/midpoint/admin/vehicle/VehicleLookupsPage";
import VehiclePriceEventsPage from "components/midpoint/admin/vehicle/VehiclePriceEventsPage";
import VehicleLifecycleEventsPage from "components/midpoint/admin/vehicle/VehicleLifecycleEventsPage";
import VehicleNormalizationIssuesPage from "components/midpoint/admin/vehicle/VehicleNormalizationIssuesPage";
import VehicleDuplicateReviewPage from "components/midpoint/admin/vehicle/VehicleDuplicateReviewPage";
import CanonicalVehiclesPage from "components/midpoint/admin/vehicle/CanonicalVehiclesPage";
import VehicleModelCopyPage from "components/midpoint/admin/vehicle/VehicleModelCopyPage";
import VehicleModelCopyQualityPage from "components/midpoint/admin/vehicle/VehicleModelCopyQualityPage";
import VehicleDataQualityPage from "components/midpoint/admin/vehicle/VehicleDataQualityPage";
import VehicleFairValuePage from "components/midpoint/admin/vehicle/VehicleFairValuePage";
import VehicleBestValuePage from "components/midpoint/admin/vehicle/VehicleBestValuePage";
import VehicleNewPriceBaselinePage from "components/midpoint/admin/vehicle/VehicleNewPriceBaselinePage";
import VehicleDepreciationAdminPage from "components/midpoint/admin/vehicle/VehicleDepreciationAdminPage";
import VehiclePredictivePricingAdminPage from "components/midpoint/admin/vehicle/VehiclePredictivePricingAdminPage";
import VehiclePricingModelsAdminPage from "components/midpoint/admin/vehicle/VehiclePricingModelsAdminPage";
import VehicleDealFinderDiagnosticsPage from "components/midpoint/admin/vehicle/VehicleDealFinderDiagnosticsPage";
import VehicleAlertsAdminPage from "components/midpoint/admin/vehicle/VehicleAlertsAdminPage";
import VehicleMarketAnalyticsPage from "components/midpoint/mobility/VehicleMarketAnalyticsPage";
import DealerCoverageDashboardPage from "components/midpoint/admin/automotive/DealerCoverageDashboardPage";
import DealerListAdminPage from "components/midpoint/admin/automotive/DealerListAdminPage";
import DealerDetailAdminPage from "components/midpoint/admin/automotive/DealerDetailAdminPage";
import DealerReviewQueuePage from "components/midpoint/admin/automotive/DealerReviewQueuePage";
import DealerGovernanceAdminPage from "components/midpoint/admin/automotive/DealerGovernanceAdminPage";
import VehicleSourceReviewPage from "components/midpoint/admin/vehicle/VehicleSourceReviewPage";
import { stashAdminDataSourcesTypeFilter } from "components/midpoint/admin/realEstateSources/adminDataSourcesFilter";
import "styles/midpoint.css";

const AppLayout = lazy(() => import("./components/midpoint/AppLayout"));

function readAutomotiveDealerDetailKeyFromHash() {
  const prefix = "#/admin/automotive-dealer-detail/";
  if (window.location.hash.startsWith(prefix)) {
    return decodeURIComponent(window.location.hash.slice(prefix.length));
  }
  return null;
}

function readAdminViewFromHash() {
  if (window.location.hash === "#/weather-intelligence") {
    return "weather-intelligence";
  }

  if (window.location.hash === "#/admin/community-reports") {
    return "moderation";
  }

  if (window.location.hash === "#/admin/data-health") {
    return "data-health";
  }

  if (window.location.hash === "#/admin/property-import") {
    return "property-import";
  }

  if (window.location.hash === "#/admin/real-estate-sources") {
    return "real-estate-sources";
  }

  if (window.location.hash === "#/admin/real-estate-source-controls") {
    return "real-estate-source-controls";
  }

  if (window.location.hash.startsWith("#/admin/data-source/")) {
    const params = new URLSearchParams(window.location.search);
    if (params.get("perspective") === "administration") {
      return null;
    }
    return "real-estate-source-controls";
  }

  if (window.location.hash === "#/admin/real-estate-source-quality") {
    return "real-estate-source-quality";
  }

  if (window.location.hash === "#/admin/real-estate-image-health") {
    return "real-estate-image-health";
  }

  if (window.location.hash === "#/admin/real-estate-image-cache") {
    return "real-estate-image-cache";
  }

  if (window.location.hash === "#/admin/real-estate-media-quality") {
    return "real-estate-media-quality";
  }

  if (window.location.hash === "#/admin/geocode-queue") {
    return "geocode-queue";
  }

  if (window.location.hash === "#/admin/real-estate-location-quality") {
    return "real-estate-location-quality";
  }

  if (window.location.hash === "#/admin/duplicate-review") {
    return "duplicate-review";
  }

  if (window.location.hash === "#/admin/canonical-listings") {
    return "canonical-listings";
  }

  if (
    window.location.hash === "#/admin/real-estate-review" ||
    window.location.hash === "#/admin/real-estate-availability-review"
  ) {
    return "real-estate-review";
  }

  if (window.location.hash === "#/admin/users") {
    return "users";
  }

  if (window.location.hash === "#/admin/roles") {
    return "roles";
  }

  if (window.location.hash === "#/admin/audit-log") {
    return "audit-log";
  }

  if (window.location.hash === "#/admin/privacy-operations") {
    return "privacy-operations";
  }

  if (window.location.hash === "#/admin/ingestion-logs") {
    return "ingestion-logs";
  }

  if (window.location.hash === "#/admin/partners") {
    return "partners";
  }

  if (window.location.hash === "#/admin/lead-broker-config") {
    return "lead-broker-config";
  }

  if (window.location.hash === "#/admin/geo-boundaries") {
    return "geo-boundaries";
  }

  if (window.location.hash === "#/admin/weather-source-controls") {
    return "weather-source-controls";
  }

  if (window.location.hash === "#/admin/finance-source-controls") {
    return "finance-source-controls";
  }

  if (window.location.hash === "#/admin/food-source-discovery") {
    return "food-source-discovery";
  }

  if (window.location.hash === "#/admin/vehicle-sources") {
    stashAdminDataSourcesTypeFilter("vehicle_market");
    window.history.replaceState(null, "", "#/admin/real-estate-source-controls");
    return "real-estate-source-controls";
  }

  if (window.location.hash === "#/admin/vehicle-source-review") {
    return "vehicle-source-review";
  }

  if (window.location.hash === "#/admin/vehicle-lookups") {
    return "vehicle-lookups";
  }

  if (window.location.hash === "#/admin/vehicle-ingestion-runs") {
    window.history.replaceState(null, "", "#/admin/ingestion-logs");
    return "ingestion-logs";
  }

  if (window.location.hash === "#/admin/vehicle-price-events") {
    return "vehicle-price-events";
  }

  if (window.location.hash === "#/admin/vehicle-lifecycle-events") {
    return "vehicle-lifecycle-events";
  }

  if (window.location.hash === "#/admin/vehicle-normalization-issues") {
    return "vehicle-normalization-issues";
  }

  if (window.location.hash === "#/admin/vehicle-duplicate-review") {
    return "vehicle-duplicate-review";
  }

  if (window.location.hash === "#/admin/canonical-vehicles") {
    return "canonical-vehicles";
  }
  if (window.location.hash === "#/admin/vehicle-model-copy") {
    return "vehicle-model-copy";
  }
  if (window.location.hash === "#/admin/vehicle-model-copy-quality") {
    return "vehicle-model-copy-quality";
  }

  if (window.location.hash === "#/admin/vehicle-source-health") {
    return "vehicle-source-health";
  }

  if (window.location.hash === "#/admin/vehicle-data-quality") {
    return "vehicle-data-quality";
  }

  if (window.location.hash === "#/admin/vehicle-fair-value") {
    return "vehicle-fair-value";
  }

  if (window.location.hash === "#/admin/vehicle-best-value") {
    return "vehicle-best-value";
  }

  if (window.location.hash === "#/admin/vehicle-new-price-baselines") {
    return "vehicle-new-price-baselines";
  }

  if (window.location.hash === "#/admin/vehicle-depreciation") {
    return "vehicle-depreciation";
  }

  if (window.location.hash === "#/admin/vehicle-predictive-pricing") {
    return "vehicle-predictive-pricing";
  }

  if (window.location.hash === "#/admin/vehicle-pricing-models") {
    return "vehicle-pricing-models";
  }

  if (window.location.hash === "#/admin/vehicle-deal-finder") {
    return "vehicle-deal-finder";
  }

  if (window.location.hash === "#/admin/vehicle-alerts") {
    return "vehicle-alerts";
  }

  if (window.location.hash === "#/admin/vehicle-market-analytics") {
    return "vehicle-market-analytics";
  }

  if (window.location.hash === "#/admin/automotive-dealer-coverage") {
    return "automotive-dealer-coverage";
  }

  if (window.location.hash === "#/admin/automotive-dealers") {
    return "automotive-dealers";
  }

  if (window.location.hash === "#/admin/automotive-dealer-review") {
    return "automotive-dealer-review";
  }

  if (window.location.hash === "#/admin/automotive-dealer-governance") {
    return "automotive-dealer-governance";
  }

  if (window.location.hash.startsWith("#/admin/automotive-dealer-detail/")) {
    return "automotive-dealer-detail";
  }

  if (window.location.hash === "#/admin/food-normalization") {
    return "food-normalization";
  }

  if (window.location.hash === "#/admin/food-basket-calculation") {
    return "food-basket-calculation";
  }

  if (window.location.hash === "#/admin/food-wholesale-ingestion") {
    return "food-wholesale-ingestion";
  }

  if (window.location.hash === "#/admin/food-retail-ingestion") {
    return "food-retail-ingestion";
  }

  if (window.location.hash === "#/admin/food-ara-normalization-review") {
    return "food-ara-normalization-review";
  }

  if (window.location.hash === "#/admin/food-supply-ingestion") {
    return "food-supply-ingestion";
  }

  if (window.location.hash === "#/admin/food-input-ingestion") {
    return "food-input-ingestion";
  }

  if (window.location.hash === "#/admin/food-access-map") {
    return "food-access-map";
  }

  if (window.location.hash === "#/admin/food-access-operations") {
    return "food-access-operations";
  }

  if (window.location.hash === "#/admin/food-store-review-queue") {
    return "food-store-review-queue";
  }

  if (window.location.hash === "#/admin/food-chain-branch-locator-strategy") {
    return "food-chain-branch-locator-strategy";
  }

  if (window.location.hash === "#/admin/food-chain-branch-imports") {
    return "food-chain-branch-imports";
  }

  if (window.location.hash === "#/admin/food-chain-locator-audits") {
    return "food-chain-locator-audits";
  }

  if (window.location.hash === "#/admin/food-store-reconciliation") {
    return "food-store-reconciliation";
  }

  if (window.location.hash === "#/admin/food-recommendations") {
    return "food-recommendations";
  }

  return null;
}

function MainApp() {
  const [adminView, setAdminView] = useState(readAdminViewFromHash);

  useEffect(() => {
    const handleHashChange = () => {
      setAdminView(readAdminViewFromHash());
    };

    window.addEventListener("hashchange", handleHashChange);
    return () => window.removeEventListener("hashchange", handleHashChange);
  }, []);

  const openModeration = () => {
    window.location.hash = "#/admin/community-reports";
    setAdminView("moderation");
  };

  const openDataHealth = () => {
    window.location.hash = "#/admin/data-health";
    setAdminView("data-health");
  };

  const openPropertyImport = () => {
    window.location.hash = "#/admin/property-import";
    setAdminView("property-import");
  };

  const openRealEstateSources = () => {
    window.location.hash = "#/admin/real-estate-sources";
    setAdminView("real-estate-sources");
  };

  const openRealEstateSourceControls = () => {
    window.location.hash = "#/admin/real-estate-source-controls";
    setAdminView("real-estate-source-controls");
  };

  const openWeatherSourceControls = () => {
    window.location.hash = "#/admin/weather-source-controls";
    setAdminView("weather-source-controls");
  };

  const openRealEstateSourceQuality = () => {
    window.location.hash = "#/admin/real-estate-source-quality";
    setAdminView("real-estate-source-quality");
  };

  const openRealEstateImageHealth = () => {
    window.location.hash = "#/admin/real-estate-image-health";
    setAdminView("real-estate-image-health");
  };

  const openRealEstateImageCache = () => {
    window.location.hash = "#/admin/real-estate-image-cache";
    setAdminView("real-estate-image-cache");
  };

  const openMediaQualityDashboard = () => {
    window.location.hash = "#/admin/real-estate-media-quality";
    setAdminView("real-estate-media-quality");
  };

  const openGeocodeQueue = () => {
    window.location.hash = "#/admin/geocode-queue";
    setAdminView("geocode-queue");
  };

  const openLocationQuality = () => {
    window.location.hash = "#/admin/real-estate-location-quality";
    setAdminView("real-estate-location-quality");
  };

  const openDuplicateReview = () => {
    window.location.hash = "#/admin/duplicate-review";
    setAdminView("duplicate-review");
  };

  const openCanonicalListings = () => {
    window.location.hash = "#/admin/canonical-listings";
    setAdminView("canonical-listings");
  };

  const openRealEstateReview = () => {
    window.location.hash = "#/admin/real-estate-availability-review";
    setAdminView("real-estate-review");
  };

  const openUsers = () => {
    window.location.hash = "#/admin/users";
    setAdminView("users");
  };

  const openRoles = () => {
    window.location.hash = "#/admin/roles";
    setAdminView("roles");
  };

  const openAuditLog = () => {
    window.location.hash = "#/admin/audit-log";
    setAdminView("audit-log");
  };

  const openPrivacyOperations = () => {
    window.location.hash = "#/admin/privacy-operations";
    setAdminView("privacy-operations");
  };

  const openIngestionLogs = () => {
    window.location.hash = "#/admin/ingestion-logs";
    setAdminView("ingestion-logs");
  };

  const openPartners = () => {
    window.location.hash = "#/admin/partners";
    setAdminView("partners");
  };

  const openLeadBrokerConfig = () => {
    window.location.hash = "#/admin/lead-broker-config";
    setAdminView("lead-broker-config");
  };

  const openFoodSourceDiscovery = () => {
    window.location.hash = "#/admin/food-source-discovery";
    setAdminView("food-source-discovery");
  };

  const openVehicleSources = () => {
    stashAdminDataSourcesTypeFilter("vehicle_market");
    window.location.hash = "#/admin/real-estate-source-controls";
    setAdminView("real-estate-source-controls");
  };

  const openRealEstateSourceControlsFromVehicle = () => {
    stashAdminDataSourcesTypeFilter("vehicle_market");
    window.location.hash = "#/admin/real-estate-source-controls";
    setAdminView("real-estate-source-controls");
  };

  const openVehicleWorkflow = (pageId) => {
    window.location.hash = `#/admin/${pageId}`;
    setAdminView(pageId);
  };

  const closeAdminView = () => {
    if (window.location.hash.startsWith("#/admin/")) {
      window.location.hash = "";
    }

    setAdminView(null);
  };

  let content;

  if (adminView === "moderation") {
    content = (
      <CommunityReportModeration
        onClose={closeAdminView}
        onOpenDataHealth={openDataHealth}
        onOpenPropertyImport={openPropertyImport}
        onOpenRealEstateSources={openRealEstateSources}
      />
    );
  } else if (adminView === "real-estate-source-controls") {
    content = (
      <RealEstateSourceControlsPage
        onClose={closeAdminView}
        onOpenModeration={openModeration}
        onOpenDataHealth={openDataHealth}
        onOpenPropertyImport={openPropertyImport}
        onOpenRealEstateSources={openRealEstateSources}
        onNavigateVehicleWorkflow={openVehicleWorkflow}
        onOpenSourceQuality={openRealEstateSourceQuality}
        onOpenImageHealth={openRealEstateImageHealth}
        onOpenImageCache={openRealEstateImageCache}
        onOpenMediaQualityDashboard={openMediaQualityDashboard}
      />
    );
  } else if (adminView === "vehicle-source-review") {
    content = (
      <VehicleSourceReviewPage
        onClose={closeAdminView}
        onOpenDataSources={openRealEstateSourceControlsFromVehicle}
      />
    );
  } else if (adminView === "vehicle-lookups") {
    content = <VehicleLookupsPage onClose={closeAdminView} />;
  } else if (adminView === "vehicle-price-events") {
    content = <VehiclePriceEventsPage onClose={closeAdminView} />;
  } else if (adminView === "vehicle-lifecycle-events") {
    content = <VehicleLifecycleEventsPage onClose={closeAdminView} />;
  } else if (adminView === "vehicle-normalization-issues") {
    content = <VehicleNormalizationIssuesPage onClose={closeAdminView} />;
  } else if (adminView === "vehicle-duplicate-review") {
    content = (
      <VehicleDuplicateReviewPage
        onClose={closeAdminView}
        onOpenCanonical={() => setAdminView("canonical-vehicles")}
      />
    );
  } else if (adminView === "canonical-vehicles") {
    content = <CanonicalVehiclesPage onClose={closeAdminView} />;
  } else if (adminView === "vehicle-model-copy") {
    content = (
      <VehicleModelCopyPage
        onClose={closeAdminView}
        onOpenQuality={() => setAdminView("vehicle-model-copy-quality")}
      />
    );
  } else if (adminView === "vehicle-model-copy-quality") {
    content = (
      <VehicleModelCopyQualityPage
        onClose={closeAdminView}
        onOpenCopyEditor={() => setAdminView("vehicle-model-copy")}
      />
    );
  } else if (adminView === "vehicle-source-health") {
    content = (
      <AdminDataHealthPage
        onClose={closeAdminView}
        onOpenModeration={openModeration}
        onOpenRealEstateSourceControls={openRealEstateSourceControls}
        onOpenWeatherSourceControls={openWeatherSourceControls}
        onOpenIngestionLogs={openIngestionLogs}
        onNavigateVehicleWorkflow={openVehicleWorkflow}
        initialDomainFilter="vehicle"
      />
    );
  } else if (adminView === "vehicle-data-quality") {
    const initialSourceId = window.sessionStorage.getItem("vehicleDataQualitySourceId") || "";
    if (initialSourceId) window.sessionStorage.removeItem("vehicleDataQualitySourceId");
    content = (
      <VehicleDataQualityPage
        onClose={closeAdminView}
        initialSourceId={initialSourceId || undefined}
        onOpenSourceHealth={() => setAdminView("vehicle-source-health")}
        onOpenNormalization={() => setAdminView("vehicle-normalization-issues")}
        onOpenDuplicates={() => setAdminView("vehicle-duplicate-review")}
        onOpenIngestionRuns={openIngestionLogs}
      />
    );
  } else if (adminView === "vehicle-fair-value") {
    content = <VehicleFairValuePage onClose={closeAdminView} />;
  } else if (adminView === "vehicle-best-value") {
    content = <VehicleBestValuePage onClose={closeAdminView} />;
  } else if (adminView === "vehicle-new-price-baselines") {
    content = <VehicleNewPriceBaselinePage onClose={closeAdminView} />;
  } else if (adminView === "vehicle-depreciation") {
    content = <VehicleDepreciationAdminPage onClose={closeAdminView} />;
  } else if (adminView === "vehicle-predictive-pricing") {
    content = <VehiclePredictivePricingAdminPage onClose={closeAdminView} />;
  } else if (adminView === "vehicle-pricing-models") {
    content = <VehiclePricingModelsAdminPage onClose={closeAdminView} />;
  } else if (adminView === "vehicle-deal-finder") {
    content = <VehicleDealFinderDiagnosticsPage onClose={closeAdminView} />;
  } else if (adminView === "vehicle-alerts") {
    content = <VehicleAlertsAdminPage onClose={closeAdminView} />;
  } else if (adminView === "vehicle-market-analytics") {
    content = <VehicleMarketAnalyticsPage adminMode onClose={closeAdminView} />;
  } else if (adminView === "automotive-dealer-coverage") {
    content = (
      <DealerCoverageDashboardPage
        onClose={closeAdminView}
        onOpenDealers={() => setAdminView("automotive-dealers")}
        onOpenReview={() => setAdminView("automotive-dealer-review")}
        onOpenDealerDetail={(profileKey) => {
          window.location.hash = `#/admin/automotive-dealer-detail/${encodeURIComponent(profileKey)}`;
          setAdminView("automotive-dealer-detail");
        }}
      />
    );
  } else if (adminView === "automotive-dealers") {
    content = (
      <DealerListAdminPage
        onClose={closeAdminView}
        onOpenDealerDetail={(profileKey) => {
          window.location.hash = `#/admin/automotive-dealer-detail/${encodeURIComponent(profileKey)}`;
          setAdminView("automotive-dealer-detail");
        }}
      />
    );
  } else if (adminView === "automotive-dealer-review") {
    content = (
      <DealerReviewQueuePage
        onClose={closeAdminView}
        onOpenDealerDetail={(profileKey) => {
          window.location.hash = `#/admin/automotive-dealer-detail/${encodeURIComponent(profileKey)}`;
          setAdminView("automotive-dealer-detail");
        }}
      />
    );
  } else if (adminView === "automotive-dealer-detail") {
    content = (
      <DealerDetailAdminPage
        profileKey={readAutomotiveDealerDetailKeyFromHash()}
        onClose={closeAdminView}
      />
    );
  } else if (adminView === "automotive-dealer-governance") {
    content = (
      <DealerGovernanceAdminPage
        onClose={closeAdminView}
        onOpenDealerDetail={(profileKey) => {
          window.location.hash = `#/admin/automotive-dealer-detail/${encodeURIComponent(profileKey)}`;
          setAdminView("automotive-dealer-detail");
        }}
      />
    );
  } else if (adminView === "real-estate-image-health") {
    content = (
      <ImageHealthPage
        onBack={closeAdminView}
        onOpenSourceQuality={openRealEstateSourceQuality}
        onOpenImageCache={openRealEstateImageCache}
      />
    );
  } else if (adminView === "real-estate-image-cache") {
    content = (
      <ImageCachePage
        onBack={closeAdminView}
        onOpenImageHealth={openRealEstateImageHealth}
        onOpenSourceQuality={openRealEstateSourceQuality}
      />
    );
  } else if (adminView === "real-estate-media-quality") {
    content = (
      <MediaQualityDashboardPage
        onClose={closeAdminView}
        onOpenImageHealth={openRealEstateImageHealth}
        onOpenImageCache={openRealEstateImageCache}
        onOpenSourceQuality={openRealEstateSourceQuality}
        onOpenRealEstateSourceControls={openRealEstateSourceControls}
        onOpenDataHealth={openDataHealth}
        onOpenPropertyImport={openPropertyImport}
        onOpenModeration={openModeration}
        onOpenGeocodeQueue={openGeocodeQueue}
        onOpenLocationQuality={openLocationQuality}
        onOpenDuplicateReview={openDuplicateReview}
        onOpenCanonicalListings={openCanonicalListings}
        onOpenRealEstateReview={openRealEstateReview}
        onOpenRealEstateSources={openRealEstateSources}
        onOpenIngestionLogs={openIngestionLogs}
        onOpenAuditLog={openAuditLog}
      />
    );
  } else if (adminView === "real-estate-source-quality") {
    content = (
      <SourceQualityPage
        onBack={closeAdminView}
        onOpenSourceControls={() => {
          openRealEstateSourceControls();
        }}
        onOpenImageHealth={openRealEstateImageHealth}
        onOpenImageCache={openRealEstateImageCache}
        onOpenMediaQualityDashboard={openMediaQualityDashboard}
      />
    );
  } else if (adminView === "data-health") {
    content = (
      <AdminDataHealthPage
        onClose={closeAdminView}
        onOpenModeration={openModeration}
        onOpenRealEstateSourceControls={openRealEstateSourceControls}
        onOpenWeatherSourceControls={openWeatherSourceControls}
        onOpenIngestionLogs={openIngestionLogs}
        onNavigateVehicleWorkflow={openVehicleWorkflow}
      />
    );
  } else if (adminView === "property-import") {
    content = (
      <AdminPropertyImportPage
        onClose={closeAdminView}
        onOpenDataHealth={openDataHealth}
        onOpenModeration={openModeration}
        onOpenRealEstateSources={openRealEstateSources}
      />
    );
  } else if (adminView === "real-estate-sources") {
    content = (
      <RealEstateSourcesPage
        onClose={closeAdminView}
        onOpenModeration={openModeration}
        onOpenDataHealth={openDataHealth}
        onOpenPropertyImport={openPropertyImport}
        onOpenGeocodeQueue={openGeocodeQueue}
        onOpenDuplicateReview={openDuplicateReview}
        onOpenCanonicalListings={openCanonicalListings}
        onOpenRealEstateReview={openRealEstateReview}
        onOpenRealEstateSourceControls={openRealEstateSourceControls}
        onOpenSourceQuality={openRealEstateSourceQuality}
        onOpenImageHealth={openRealEstateImageHealth}
        onOpenImageCache={openRealEstateImageCache}
        onOpenMediaQualityDashboard={openMediaQualityDashboard}
      />
    );
  } else if (adminView === "real-estate-review") {
    content = (
      <RealEstateReviewQueuePage
        onClose={closeAdminView}
        onOpenModeration={openModeration}
        onOpenDataHealth={openDataHealth}
        onOpenPropertyImport={openPropertyImport}
        onOpenRealEstateSources={openRealEstateSources}
        onOpenGeocodeQueue={openGeocodeQueue}
        onOpenDuplicateReview={openDuplicateReview}
        onOpenCanonicalListings={openCanonicalListings}
      />
    );
  } else if (adminView === "geocode-queue") {
    content = (
      <GeocodeQueuePage
        onClose={closeAdminView}
        onOpenModeration={openModeration}
        onOpenDataHealth={openDataHealth}
        onOpenPropertyImport={openPropertyImport}
        onOpenRealEstateSources={openRealEstateSources}
        onOpenDuplicateReview={openDuplicateReview}
        onOpenCanonicalListings={openCanonicalListings}
        onOpenLocationQuality={openLocationQuality}
      />
    );
  } else if (adminView === "real-estate-location-quality") {
    content = (
      <LocationQualityPage
        onClose={closeAdminView}
        onOpenGeocodeQueue={openGeocodeQueue}
        onOpenDataHealth={openDataHealth}
        onOpenRealEstateSources={openRealEstateSources}
        onOpenCanonicalListings={openCanonicalListings}
        onOpenDuplicateReview={openDuplicateReview}
        onOpenPropertyImport={openPropertyImport}
        onOpenModeration={openModeration}
        onOpenSourceQuality={openRealEstateSourceQuality}
        onOpenRealEstateSourceControls={openRealEstateSourceControls}
        onOpenImageHealth={openRealEstateImageHealth}
        onOpenImageCache={openRealEstateImageCache}
        onOpenMediaQualityDashboard={openMediaQualityDashboard}
        onOpenIngestionLogs={openIngestionLogs}
        onOpenAuditLog={openAuditLog}
        onOpenRealEstateReview={openRealEstateReview}
      />
    );
  } else if (adminView === "duplicate-review") {
    content = (
      <DuplicateReviewPage
        onClose={closeAdminView}
        onOpenModeration={openModeration}
        onOpenDataHealth={openDataHealth}
        onOpenPropertyImport={openPropertyImport}
        onOpenRealEstateSources={openRealEstateSources}
        onOpenGeocodeQueue={openGeocodeQueue}
        onOpenCanonicalListings={openCanonicalListings}
      />
    );
  } else if (adminView === "weather-intelligence") {
    content = (
      <WeatherIntelligenceDashboardPage
        onClose={() => {
          window.location.hash = "";
          setAdminView(null);
        }}
        onOpenMap={() => {
          window.location.hash = "";
          setAdminView(null);
        }}
      />
    );
  } else if (adminView === "canonical-listings") {
    content = (
      <CanonicalListingsPage
        onClose={closeAdminView}
        onOpenModeration={openModeration}
        onOpenDataHealth={openDataHealth}
        onOpenPropertyImport={openPropertyImport}
        onOpenRealEstateSources={openRealEstateSources}
        onOpenGeocodeQueue={openGeocodeQueue}
        onOpenDuplicateReview={openDuplicateReview}
      />
    );
  } else if (adminView === "users") {
    content = <AdminUsersPage onClose={closeAdminView} />;
  } else if (adminView === "roles") {
    content = <AdminRolesPage onClose={closeAdminView} />;
  } else if (adminView === "audit-log") {
    content = (
      <AdminAuditLogPage onClose={closeAdminView} onOpenIngestionLogs={openIngestionLogs} />
    );
  } else if (adminView === "privacy-operations") {
    content = <AdminPrivacyOperationsPage onClose={closeAdminView} />;
  } else if (adminView === "ingestion-logs") {
    content = (
      <AdminIngestionLogsPage
        onClose={closeAdminView}
        onOpenAuditLog={openAuditLog}
        onOpenDataHealth={openDataHealth}
        onOpenRealEstateSourceControls={openRealEstateSourceControls}
      />
    );
  } else if (adminView === "partners") {
    content = <AdminPartnersPage />;
  } else if (adminView === "lead-broker-config") {
    content = <AdminLeadBrokerConfigPage />;
  } else if (adminView === "geo-boundaries") {
    content = <AdminGeoBoundariesPage onClose={closeAdminView} />;
  } else if (adminView === "food-source-discovery") {
    content = <FoodSourceDiscoveryPage onClose={closeAdminView} />;
  } else if (adminView === "food-normalization") {
    content = <FoodNormalizationPage onClose={closeAdminView} />;
  } else if (adminView === "food-basket-calculation") {
    content = <FoodBasketCalculationPage onClose={closeAdminView} />;
  } else if (adminView === "food-wholesale-ingestion") {
    content = <FoodWholesaleIngestionPage onClose={closeAdminView} />;
  } else if (adminView === "food-retail-ingestion") {
    content = <FoodRetailIngestionPage onClose={closeAdminView} />;
  } else if (adminView === "food-ara-normalization-review") {
    content = <FoodNormalizationReviewPage onClose={closeAdminView} />;
  } else if (adminView === "food-supply-ingestion") {
    content = <FoodSupplyIngestionPage onClose={closeAdminView} />;
  } else if (adminView === "food-input-ingestion") {
    content = <FoodInputIngestionPage onClose={closeAdminView} />;
  } else if (adminView === "food-access-map") {
    content = <FoodAccessAdminPage onClose={closeAdminView} />;
  } else if (adminView === "food-access-operations") {
    content = <FoodAccessOperationsPage onClose={closeAdminView} />;
  } else if (adminView === "food-store-review-queue") {
    content = <FoodStoreReviewQueuePage onClose={closeAdminView} />;
  } else if (adminView === "food-chain-branch-locator-strategy") {
    content = <FoodChainBranchLocatorStrategyPage onClose={closeAdminView} />;
  } else if (adminView === "food-chain-branch-imports") {
    content = <FoodChainBranchImportsPage onClose={closeAdminView} />;
  } else if (adminView === "food-chain-locator-audits") {
    content = <ChainLocatorAuditPage onClose={closeAdminView} />;
  } else if (adminView === "food-store-reconciliation") {
    content = <FoodStoreReconciliationPage onClose={closeAdminView} />;
  } else if (adminView === "food-recommendations") {
    content = <FoodRecommendationAdminPage onClose={closeAdminView} />;
  } else if (adminView === "weather-source-controls") {
    content = (
      <RealEstateSourceControlsPage
        onClose={closeAdminView}
        onOpenModeration={openModeration}
        onOpenDataHealth={openDataHealth}
        onOpenPropertyImport={openPropertyImport}
        onOpenRealEstateSources={openRealEstateSources}
        onNavigateVehicleWorkflow={openVehicleWorkflow}
        onOpenSourceQuality={openRealEstateSourceQuality}
        onOpenImageHealth={openRealEstateImageHealth}
        onOpenImageCache={openRealEstateImageCache}
        onOpenMediaQualityDashboard={openMediaQualityDashboard}
        initialTypeFilter="weather"
      />
    );
  } else if (adminView === "finance-source-controls") {
    content = (
      <RealEstateSourceControlsPage
        onClose={closeAdminView}
        onOpenModeration={openModeration}
        onOpenDataHealth={openDataHealth}
        onOpenPropertyImport={openPropertyImport}
        onOpenRealEstateSources={openRealEstateSources}
        onNavigateVehicleWorkflow={openVehicleWorkflow}
        onOpenSourceQuality={openRealEstateSourceQuality}
        onOpenImageHealth={openRealEstateImageHealth}
        onOpenImageCache={openRealEstateImageCache}
        onOpenMediaQualityDashboard={openMediaQualityDashboard}
        initialTypeFilter="finance"
      />
    );
  } else {
    const openWeatherIntelligence = () => {
      window.location.hash = "#/weather-intelligence";
      setAdminView("weather-intelligence");
    };

    content = (
      <Suspense
        fallback={
          <div className="midpoint-app midpoint-loading">
            Loading Midpoint Map: Community Intelligence Platform.
          </div>
        }
      >
        <AppLayout
          onOpenModeration={openModeration}
          onOpenDataHealth={openDataHealth}
          onOpenPropertyImport={openPropertyImport}
          onOpenRealEstateSources={openRealEstateSources}
          onOpenRealEstateSourceControls={openRealEstateSourceControls}
          onOpenGeocodeQueue={openGeocodeQueue}
          onOpenDuplicateReview={openDuplicateReview}
          onOpenCanonicalListings={openCanonicalListings}
          onOpenAvailabilityReview={openRealEstateReview}
          onOpenWeatherIntelligence={openWeatherIntelligence}
          onOpenUsers={openUsers}
          onOpenRoles={openRoles}
          onOpenAuditLog={openAuditLog}
          onOpenPrivacyOperations={openPrivacyOperations}
          onOpenIngestionLogs={openIngestionLogs}
          onOpenPartners={openPartners}
          onOpenLeadBrokerConfig={openLeadBrokerConfig}
          onOpenFoodSourceDiscovery={openFoodSourceDiscovery}
        />
      </Suspense>
    );
  }

  return (
    <RequireAuth>
      <ProtectedAdminGate adminView={adminView}>{content}</ProtectedAdminGate>
    </RequireAuth>
  );
}

export default MainApp;
